import { RevealOnScroll } from '../classes/RevealOnScroll';

document.addEventListener('DOMContentLoaded', () => {
	const delay = 1;

	for (const materialsSection of Array.from(document.querySelectorAll('.materials'))) {
		materialsSection.classList.add('materials--ready');
	}

	for (const materialsSection of Array.from(document.querySelectorAll('.materials'))) {
		new RevealOnScroll('#' + materialsSection.id, {
			onReveal: (revealedElements) => {
				const labels = Array.from(revealedElements[0].querySelectorAll('.materials__label'));
				if (labels.length > 0) {
					labels.sort((labelA, labelB) => {
						return Number((labelA as HTMLElement).dataset.order) - Number((labelB as HTMLElement).dataset.order);
					});
					for (let i = 0; i < labels.length; i++) {
						setTimeout(
							() => {
								labels[i].classList.add('materials__label--play');
							},
							(i + 1) * 1000 * delay
						);
					}
				}
			},
		});
	}
});
